
import Vue from 'vue'
// import VueRouter from 'vue-router'
import Yomo from './Yomo.vue'
import YomoFR from './YomoFR.vue'
// import App from './App'

// Vue.use(VueRouter)

Vue.config.productionTip = false

// const routes = [
//   { path: '/en', component: Yomo },
//   { path: '/fr', component: YomoFR },
// ]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
// const router = new VueRouter({
//   routes // short for `routes: routes`
// })

var urlParams = new URLSearchParams(window.location.search);
var component = Yomo;

if (urlParams.has('lang')){
  if (urlParams.get('lang') == 'fr'){
    component = YomoFR;
  }
}

new Vue({
  render: h => h(component),
  // router
}).$mount('#app')
